module.exports = __webpack_public_path__ + "static/2.5RealeaseObject-8d77321dcb53f96db190654b1272d030.gif";